import React, { Component } from "react";
import { authService } from "../../../auth";
import { getCDNUrl } from "../../../commons/CommonFunctions";
import { Link, NavLink } from "react-router-dom";
import MutualConnect from "../../../commons/MutualConnect";
import Follow from "../../../commons/Follow";
import {redirectToProfile} from './HashtagsCommonFunction';


class CommonHashTagsForum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            loginSuccess: authService.isAuthenticated(),
        }
    }

    getOptimizedImage = (personalInfo) => {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }
        return personalInfo.profileImage || personalInfo.userProfileImage;
    }

    render() {
        return (
            <div className="col-md-6">
                <div className="forumrow">
                    <h4>
                        <Link to={`/forumDetail/${(this.props.item.slug || this.props.item?.metaData?.slug)}`}>
                            <i className="iPolls" />{this.props.item.title || this.props.item?.metaData?.title}
                        </Link>
                    </h4>
                    <div className="forumrowbott">
                        <div className= {"fuserfollow" + (this.props.item.userType === "COMPANY" ? " orgnzName" : "")}>
                            <figure className="userlogo" style={{ cursor: 'pointer' }} onClick={(e) => {
                                e.preventDefault();
                                redirectToProfile(this.props.item.customUrl || this.props.item?.userCustomUrl);
                            }}>
                                <Link to={'/profile/' + (this.props.item.customUrl || this.props.item?.userCustomUrl)}><img
                                    src={(this.props.item.profileImage != null || this.props.item?.userProfileImage !== null) ? getCDNUrl(this.getOptimizedImage(this.props.item)) : (this.props.item.userType !== "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                                    alt="" /></Link></figure>
                            <Link to={'/profile/' + (this.props.item.customUrl || this.props.item?.userCustomUrl)}>{this.props.item.userName}</Link>
                            {this.state.loginSuccess === true ? ((this.props.item.connectDepth && this.props.item.userId != this.state.userData.userId) ?
                                <MutualConnect connectDepth={this.props.item.connectDepth}></MutualConnect> : null) : null}
                            {this.state.loginSuccess === true && (this.props.item.connectDepth !== 1 && this.props.item.connectDepth !== 2) ? (this.props.item.userConnectStatus && this.props.item.userConnectStatus.connectStatus === "PENDING_CONNECT" ?
                                <>
                                    <NavLink className="follow follow-link active" to="/connected" data-tip="msg to show" data-place='bottom' data-for={'Pending' + this.props.item.userId}><i className="iTickedUser" /> Pending</NavLink>
                                </>
                                : this.props.item.userConnectStatus && this.props.item.userConnectStatus.connectStatus === 'REQUEST_RECEIVED' ?
                                    <>
                                        <NavLink className="follow follow-link active" to="/manage-invitation" data-tip="msg to show" data-place='bottom' data-for={'Pending' + this.props.item.userId}><i className="iTickedUser" /> Pending</NavLink>
                                    </>
                                    : this.props.item.userConnectStatus && this.props.item.userConnectStatus.connectStatus === 'DEADLOCK_PENDING_STATUS' ?
                                        <></>

                                        : this.props.item && (!this.props.item.connectDepth || (this.props.item.connectDepth && this.props.item.connectDepth < 1)) &&
                                        <Follow followed={this.props.item.followed} userId={this.props.item.userId} deactivated={this.props.item.deactivated} />
                            ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CommonHashTagsForum;